import { render, staticRenderFns } from "./AddMerchantInfo.vue?vue&type=template&id=2653b18b&scoped=true"
import script from "./AddMerchantInfo.vue?vue&type=script&lang=js"
export * from "./AddMerchantInfo.vue?vue&type=script&lang=js"
import style0 from "./AddMerchantInfo.vue?vue&type=style&index=0&id=2653b18b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2653b18b",
  null
  
)

export default component.exports